import type { IconSvgObject } from './types';

const StrokeInsideIcon: IconSvgObject = [
  ["path", { d: "M11.5 22H21C21.5523 22 22 21.5523 22 21V14C22 13.4477 21.5523 13 21 13H12C11.4477 13 11 12.5523 11 12V3C11 2.44771 10.5523 2 10 2L3 2C2.44772 2 2 2.44772 2 3L2 12.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8 19C8 20.6569 6.65685 22 5 22C3.34315 22 2 20.6569 2 19C2 17.3431 3.34315 16 5 16C6.65685 16 8 17.3431 8 19Z", stroke: "currentColor", strokeWidth: "1.5", key: "1" }]
];

export default StrokeInsideIcon;
